export interface ApiRequestParams<TRequestData = any> {
  url: string;

  data?: TRequestData;
  formData?: boolean;
  method?: string;
  options?: RequestInit;
}

export interface AbortableApiRequestParams<TRequestData = any>
  extends ApiRequestParams<TRequestData> {
  abortSignal?: AbortSignal;
}

export const isAbortableApiRequestParams = <TRequestData = any>(
  x:
    | ApiRequestParams<TRequestData>
    | AbortableApiRequestParams<TRequestData>
    | undefined,
): x is AbortableApiRequestParams<TRequestData> => !!x && 'abortSignal' in x;
